var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#E5393C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1114_14541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.064 13.51C9.89601 11.8532 11.1724 10.4605 12.7504 9.48747C14.3285 8.51443 16.1461 7.99942 18 8C20.695 8 22.959 8.99 24.69 10.605L21.823 13.473C20.786 12.482 19.468 11.977 18 11.977C15.395 11.977 13.19 13.737 12.405 16.1C12.205 16.7 12.091 17.34 12.091 18C12.091 18.66 12.205 19.3 12.405 19.9C13.191 22.264 15.395 24.023 18 24.023C19.345 24.023 20.49 23.668 21.386 23.068C21.9054 22.726 22.3501 22.2822 22.6932 21.7635C23.0363 21.2448 23.2706 20.6619 23.382 20.05H18V16.182H27.418C27.536 16.836 27.6 17.518 27.6 18.227C27.6 21.273 26.51 23.837 24.618 25.577C22.964 27.105 20.7 28 18 28C16.6866 28.0005 15.386 27.7422 14.1725 27.2399C12.9591 26.7375 11.8565 26.0009 10.9278 25.0722C9.99907 24.1436 9.2625 23.041 8.76013 21.8275C8.25777 20.614 7.99948 19.3134 8 18C8 16.386 8.386 14.86 9.064 13.51Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1114_14541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialGoogle);
export default __webpack_public_path__ + "static/media/social-google.f7e9c67343902e7367504e6b1f353039.svg";
export { ForwardRef as ReactComponent };